/**
 * Angular import.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

/**
 * Components import.
 */
import { EditorChoiceComponent } from './editor-choice.component';
import { EditorChoiceDetailComponent } from './editor-choice-detail/editor-choice-detail.component';

/**
 * Editor choice routes.
 */
const editorChoiceRoutes: Routes = [
  { path: '', component: EditorChoiceComponent, canActivate: [AuthGuard],
    children: [
      { path: ':id', component: EditorChoiceDetailComponent }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(editorChoiceRoutes)
  ],
  exports: [RouterModule],
  providers: [AuthGuard],
})

export class EditorChoiceRoutingModule { }
